import { TypedActionTree, TypedMutationTree } from '../CustomFundamentalStoreContracts';
import { IRootActions, IRootGetters, IRootMutations, IRootState } from './rootTypes';

const rootState: IRootState = {} as IRootState;

const mutations: TypedMutationTree<IRootMutations, IRootState> = {};

const actions: TypedActionTree<IRootActions, IRootMutations, IRootGetters, IRootState, IRootState> = {};

export const rootOptions = {
  actions,
  mutations,
  state: rootState,
};
